export class UserRole {
    public static readonly ADMIN = "Admin";
    public static readonly NONE = "None";
}